import { render, staticRenderFns } from "./DialogHistorico.vue?vue&type=template&id=3cf098a2&scoped=true&"
import script from "./DialogHistorico.vue?vue&type=script&lang=js&"
export * from "./DialogHistorico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf098a2",
  null
  
)

export default component.exports